import type { HotelogixImporterComponentProps } from './HotelogixImporterComponent';

export const HotelogixImporterComponent = {
    MountAsync: async (target: HTMLElement, props: HotelogixImporterComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { HotelogixImporterComponent } = await import('./HotelogixImporterComponent');
        return await mountReactComponentAsync(target, HotelogixImporterComponent, props);
    }
};
